

// Dynamically extract column keys from the first object


// export const getReportViewColumns = (reportData) => {
//   const columnKeys = reportData?.length > 0 ? Object.keys(reportData[0]) : [];

//   return columnKeys.map((key) => ({
//     accessorKey: key.replace(/\s+/g, ''),
//     header: key,
//     filterVariant: 'text',
//     filterFn: (row, columnId, filterValue) =>
//       row.getValue(columnId).toString().toLowerCase().includes(filterValue.toLowerCase())
//   }));
// };

//---------------------------------------------------------------------------------------------------------------

// Utility to convert various date string formats to local timezone string
export function formatUTCToLocal(dateStr) {
  if (!dateStr) return "";

  let date;
  // Check for dd-mm-yyyy hh:mm:ss (assumed UTC)
  if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(dateStr)) {
    const [day, month, yearAndTime] = dateStr.split("-");
    const [year, time] = yearAndTime.split(" ");
    const [hour, minute, second] = time.split(":");
    // Create date as UTC
    date = new Date(Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    ));
  }
  // Check for ISO format (2025-06-19T11:15:44 or 2025-06-19T11:15:44Z)
  else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateStr)) {
    date = new Date(dateStr.endsWith("Z") ? dateStr : dateStr + "Z");
  } else {
    // Fallback: try native Date parsing
    date = new Date(dateStr);
  }

  if (isNaN(date.getTime())) return dateStr; // Invalid date, return as is

  // Format as DD-MM-YYYY HH:mm:ss in local time
  const pad = n => n.toString().padStart(2, '0');
  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export const formatUTCToOffset = (dateStr, offsetMinutes = 0) => {
  if (!dateStr) return "";

  let date;

  // dd-mm-yyyy hh:mm:ss (UTC)
  if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(dateStr)) {
    const [day, month, yearAndTime] = dateStr.split("-");
    const [year, time] = yearAndTime.split(" ");
    const [hour, minute, second] = time.split(":");

    date = new Date(Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    ));
  }

  // ISO format
  else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateStr)) {
    date = new Date(dateStr.endsWith("Z") ? dateStr : dateStr + "Z");
  }

  // yyyy-mm-dd hh:mm:ss (UTC)
  else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateStr)) {
    const [datePart, timePart] = dateStr.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hour, minute, second] = timePart.split(":");

    date = new Date(Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    ));
  }

  // fallback
  else {
    date = new Date(dateStr);
  }

  if (isNaN(date.getTime())) return dateStr;

  const offsetDate = new Date(date.getTime() + offsetMinutes * 60 * 1000);

  const pad = n => n.toString().padStart(2, "0");

  return `${pad(offsetDate.getUTCDate())}-${pad(offsetDate.getUTCMonth() + 1)}-${offsetDate.getUTCFullYear()} ` +
         `${pad(offsetDate.getUTCHours())}:${pad(offsetDate.getUTCMinutes())}:${pad(offsetDate.getUTCSeconds())}`;
};


export const getReportViewColumns = (reportColumns, reportData) => {
  // Only include columns with UseFlag === 1 and exclude the internal OffsetMinutes column from the UI
  const filteredColumns = reportColumns.filter(col => col.UseFlag === 1 && col.DisplayColumnName !== 'OffsetMinutes');

  return filteredColumns.map((col) => {
    const accessorKey = col.DisplayColumnName.replace(/\s+/g, "");

    // Dynamically generate filterSelectOptions for columns with few unique values
    let filterSelectOptions;
    const uniqueVals = [
      ...new Set(
        reportData
          .map(row => row[col.DisplayColumnName] ?? row[col.DisplayColumnName])
          .filter(val => val !== undefined && val !== null)
          .map(val => String(val))
      )
    ];
    
    if (["SiteName", "DeviceType"].includes(col.DisplayColumnName)) {
      filterSelectOptions = uniqueVals;
    }

    return {
    accessorKey,
    header: col.DisplayColumnName,
    filterVariant: filterSelectOptions ? 'multi-select' : 'text',
    filterSelectOptions,
    Cell: ({ cell }) => {
      const cellValue = cell.getValue();
      // Format date strings using OffsetMinutes column if present; otherwise convert to local timezone
      if (col.ColumnDataType === 'DateTime') {
        const row = cell.row?.original || {};
        const hasOffset = Object.prototype.hasOwnProperty.call(row, 'OffsetMinutes') || Object.prototype.hasOwnProperty.call(row, 'offsetMinutes');
        if (hasOffset) {
          const offsetVal = row.OffsetMinutes ?? row.offsetMinutes ?? 0;
          return formatUTCToOffset(cellValue, offsetVal);
        }
        return formatUTCToLocal(cellValue);
      }
      // For other data types, return as is
      return cellValue;
    },
    filterFn: filterSelectOptions
      ? 'arrIncludesSome'
      : (row, columnId, filterValue) => {
          const cellValue = row.getValue(columnId);
          return (cellValue ?? "").toString().toLowerCase().includes(filterValue.toLowerCase());
        },
  };
});
};

//---------------------------------------------------------------------------------------------------------------

// export const getReportViewColumns = (reportData) => {
//   const columnKeys = reportData?.length > 0 ? Object.keys(reportData[0]) : [];

//   return columnKeys.map((key) => {
//     const accessorKey = key.replace(/\s+/g, '');
//     // Only add filterSelectOptions for columns you want a dropdown for
//     let filterSelectOptions;
//     if (["Site Name", "Status"].includes(key)) {
//       filterSelectOptions = [
//         ...new Set(reportData.map(row => row[key]).filter(Boolean))
//       ];
//     }

//     return {
//       accessorKey,
//       header: key,
//       filterVariant: filterSelectOptions ? 'multi-select' : 'text',
//       filterSelectOptions,
//       filterFn: filterSelectOptions
//         ? 'arrIncludesSome'
//         : (row, columnId, filterValue) =>
//             row.getValue(columnId).toString().toLowerCase().includes(filterValue.toLowerCase()),
//     };
//   });
// };